'use client';

import dynamic from 'next/dynamic'
import { useRouter } from 'next/navigation';
import { useAuthToken } from '@/store/auth';
import { Maybe } from '@nf/utils-common/fpw/monadic';
import { MyBetsButton } from '@/components/feature-buttons/my-bets-button';
import { AccountTooltip } from '@/features/profile/account-tooltip';
import { useAccountStatus } from '@/hooks/query/account';
import { LicenseeTypeEnums } from '@nf/types/site';
import { siteService } from '@/services/site.service';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import clsx from 'clsx';
import { headerStyle } from '../header.style';

const ProfileSection = dynamic(() =>
	import('@/features/profile/profile-section').then(mod => mod.ProfileSection)
);

export const HeaderAccount = () => {
	const authToken = useAuthToken();
	const router = useRouter();
	const { data: actStatus } = useAccountStatus();
	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
	const view = useAppearanceStore(state => state.view);

	const handleVisit = () => {
		router.push('/onelogin');
	};

	return (
		<div className={clsx('header__account', { [headerStyle.headerAccountHidden]: view === ViewEnum.mars })}>
			{Maybe(authToken).fold(
				() => null,
				() => (
					<>
						<ProfileSection />
						{actStatus === 2 ? (!isAthena || view !== ViewEnum.galaxy) && <MyBetsButton from="header" /> : null}
						<AccountTooltip position="avatar" />
					</>
					//  (

					// 	<>
					// 		 <Button
					// 			variant="primary"
					// 			shape="capsule"
					// 			onClick={handleVisit}
					// 		>
					// 			<span className="btn__text">LOGIN</span>
					// 		</Button> 

					// 	</>
					// )
				)
			)}
		</div>
	);
};